/**
 * Gennemsigtig header over en hero.
 *
 * Canopy har ingen indstilling for det, saa vi goer det selv: ligger den
 * foerste sektion paa siden en fuldbredde-hero, laegger headeren sig oven paa
 * den uden baggrund. Saa snart man ruller forbi heroen, bliver den fast igen.
 *
 * Klasserne saettes paa <html>, saa CSS kan naa baade header og hero.
 */
(function () {
  var HERO = '.bg-video-section, .image-banner, .slideshow, .video-section';
  var rod = document.documentElement;

  function start() {
    var main = document.querySelector('#MainContent, main');
    if (!main) return;

    var foerste = main.querySelector('.shopify-section');
    if (!foerste) return;

    var hero = foerste.matches(HERO) ? foerste : foerste.querySelector(HERO);
    if (!hero) return;

    // Heroen skal vaere det foerste paa siden, ellers giver det ingen mening
    if (foerste.previousElementSibling && foerste.previousElementSibling.querySelector(HERO)) return;

    var header = document.querySelector('store-header');
    var hoejde = header ? header.getBoundingClientRect().height : 90;

    /* Kun naar heroen gaar helt ud til kanten.
       Indre sider (Om os, Vores emballage) har et banner med sidemargen.
       Gik headeren gennemsigtig der, kom den hvide skrift til at staa paa den
       lyse side i stedet for paa billedet.

       12/9: vi maalte bredden, og det var en RACE. Paa et koldt load kunne
       maalingen naa at ske foer layoutet var faldet paa plads, saa et indrykket
       banner blev maalt som fuld bredde. Klassen blev sat og aldrig fjernet
       igen, saa Om os fik overlay-header med en streg tvaers over siden — men
       kun nogle gange, hvilket er den vaerste slags fejl. Ved genindlaesning
       saa den rigtig ud.

       Nu spoerger vi markup'en i stedet: Liquid saetter section--full-width paa
       wrapperen (image-banner, slideshow, background-video bruger alle den
       konvention). Det er kendt paa serveren og kan ikke naa at vaere forkert.
       Maalingen er reserve for hero-typer uden .section-wrapper. */
    function fuldBredde() {
      var sektion = hero.closest ? hero.closest('.section') : null;
      if (sektion) return sektion.classList.contains('section--full-width');
      return hero.getBoundingClientRect().width >= document.documentElement.clientWidth - 2;
    }

    function opdater() {
      var bund = hero.getBoundingClientRect().bottom;
      rod.classList.toggle('nt-header-fast', bund <= hoejde);
    }

    /* Vurderes igen ved load og resize, saa en forkert tilstand retter sig selv
       i stedet for at haenge fast resten af besoeget. */
    function vurder() {
      var paa = fuldBredde();
      rod.classList.toggle('nt-hero-top', paa);
      if (!paa) {
        rod.classList.remove('nt-header-fast');
        return;
      }
      opdater();
    }

    vurder();
    window.addEventListener('load', vurder);
    window.addEventListener('scroll', function () {
      if (rod.classList.contains('nt-hero-top')) opdater();
    }, { passive: true });
    window.addEventListener('resize', function () {
      hoejde = header ? header.getBoundingClientRect().height : 90;
      vurder();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
